import * as z from "zod/v4";

export const refreshTeamRates = {
  name: "refreshTeamRates" as const,
  input: z.object({ teamId: z.string() }),
  output: z.null(),
  description: "Refresh outbound rates for a team",
};

export const getPendingRatesCount = {
  name: "getPendingRatesCount" as const,
  input: z.object({ teamId: z.string() }),
  output: z.number(),
  description:
    "Get the count of fulfillment groups with pending rates for a team",
};

export const resyncFulfillmentGroups = {
  name: "resyncFulfillmentGroups" as const,
  input: z.object({ teamId: z.string() }),
  output: z.null(),
  description: "Flag fulfillment groups for resync in a team",
};

export const getGroupsNeedingResyncCount = {
  name: "getGroupsNeedingResyncCount" as const,
  input: z.object({ teamId: z.string() }),
  output: z.number(),
  description:
    "Get the count of fulfillment groups flagged for resync for a team",
};
